// extracted by mini-css-extract-plugin
module.exports = {"MainDashboardContainer":"index_MainDashboardContainer__Fl30z","GridBackground":"index_GridBackground__1ZSPM"};